module.exports = __webpack_public_path__ + "img/agreement.05c7f423.jpg";